import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import MortgageRateTrends from "./MortgageRateTrends.esm.js";
import { FieldConfig } from "./MortgageRateTrends.utils.esm.js";
import { STATE_NAMES } from "./constants.esm.js";
const MortgageRatesTrendsBlock = {
  Component: ({
    attrs,
    pathName
  }) => {
    const {
      loanPurpose = "Purchase",
      creditRating = "740 or higher",
      location = "United States",
      percentDown = "20% or higher",
      timeSpan = 365,
      Fixed30Year = true,
      Fixed20Year = false,
      Fixed10Year = false,
      Fixed15Year = false,
      ARM7 = false,
      ARM5 = false,
      ARM3 = false
    } = attrs;
    pathName = "/mortgage-rates/";
    const defaultValues = {
      loanPurpose,
      creditRating,
      location,
      percentDown,
      timeSpan,
      Fixed30Year,
      Fixed20Year,
      Fixed15Year,
      Fixed10Year,
      ARM7,
      ARM5,
      ARM3
    };
    const editorMode = isEditor();
    return /* @__PURE__ */ jsx(MortgageRateTrends, { defaultValues, editorMode, pathName });
  },
  metadata: {
    version: "1.0",
    name: "constellation/mortgageratetrends",
    title: "Mortgage Rate Trends",
    description: "Interactive graph to see historical mortgage rates tailored by loan program, credit score, down payment and location.",
    icon: "chart-line",
    keywords: ["mortgages", "rates", "trends"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Layout",
    attributes: {
      [FieldConfig.loanPurpose.name]: {
        type: "string",
        default: "Purchase",
        label: "Default loan purpose",
        control: "select",
        choices: [{
          label: "Purchase",
          value: "Purchase"
        }, {
          label: "Refinance",
          value: "Refinance"
        }]
      },
      [FieldConfig.creditRating.name]: {
        type: "string",
        default: "740 or higher",
        label: "Default credit rating",
        control: "select",
        choices: [{
          label: "740 or higher",
          value: "740 or higher"
        }, {
          label: "680 - 740",
          value: "680 - 740"
        }, {
          label: "Less than 680",
          value: "Less than 680"
        }]
      },
      [FieldConfig.location.name]: {
        type: "string",
        label: "Default location",
        default: "United States",
        control: "select",
        choices: STATE_NAMES.map((label) => ({
          label,
          value: label
        }))
      },
      [FieldConfig.percentDown.name]: {
        type: "string",
        default: "20% or higher",
        label: "Default percent down",
        control: "select",
        choices: [{
          label: "20% or higher",
          value: "20% or higher"
        }, {
          label: "5% - 20%",
          value: "5% - 20%"
        }, {
          label: "Less than 5%",
          value: "Less than 5%"
        }]
      },
      [FieldConfig.timeSpan.name]: {
        type: "number",
        default: 365,
        label: "Default timespan",
        control: "select",
        choices: [{
          label: "1 day",
          value: 1
        }, {
          label: "7 days",
          value: 7
        }, {
          label: "1 month",
          value: 30
        }, {
          label: "3 months",
          value: 90
        }, {
          label: "1 year",
          value: 365
        }, {
          label: "2 years",
          value: 730
        }]
      },
      [FieldConfig.Fixed30Year.name]: {
        type: "boolean",
        label: "Default 30 year fixed",
        default: true,
        control: "boolean"
      },
      [FieldConfig.Fixed20Year.name]: {
        type: "boolean",
        label: "Default 20 year fixed",
        default: false,
        control: "boolean"
      },
      [FieldConfig.Fixed15Year.name]: {
        type: "boolean",
        label: "Default 15 year fixed",
        default: false,
        control: "boolean"
      },
      [FieldConfig.Fixed10Year.name]: {
        type: "boolean",
        label: "Default 10 year fixed",
        default: false,
        control: "boolean"
      },
      [FieldConfig.ARM7.name]: {
        type: "boolean",
        label: "Default 7-year ARM",
        default: false,
        control: "boolean"
      },
      [FieldConfig.ARM5.name]: {
        type: "boolean",
        label: "Default 5-year ARM",
        default: false,
        control: "boolean"
      },
      [FieldConfig.ARM3.name]: {
        type: "boolean",
        label: "Default 3-year ARM",
        default: false,
        control: "boolean"
      }
    }
  }
};
export {
  MortgageRatesTrendsBlock as default
};
